import React, { Children, useContext } from 'react';
import { CartContext } from "components/cart";
import classNames from 'lib/classNames';
import Axios from 'axios';
import { getAddedGifts } from '../Utils';

export default function MultiGiftWithPurchaseWidget ({ giftGoal, previous_goal, filteredItems, add_to_unlock }) {
    const { multi_goal_type } = add_to_unlock
    const {
        get_total,
        Utils,
        campaigns,
        cart_settings: {
            rtl,
            money_format,
            product
        },
        shopify_cart_items,
        giftCurrentPreview,
        isPreview,
        productAddedToCart,
        setVariantPickerOptions,
        setVariantsPickerShow,
        productionAddToCart,
        setCartItems
    } = useContext(CartContext);
    const bundlesDiscounts = Utils.getDiscount({ campaigns, items: shopify_cart_items, getBundlesOnly: true });
    const { original, subtotal } = get_total(null, filteredItems);
    const { gift, goal } = giftGoal
    const { widget, multi_gift_select } = gift
    const formattedGoal = parseInt(goal * 100)
    const amount = original - bundlesDiscounts
    const rate = parseFloat(window.Shopify.currency.rate)
    const replacedAmountValue = (formattedGoal * rate) - amount
    const byQuantity = multi_goal_type === "quantity"
    const goalValue = byQuantity ? goal : parseInt(goal * 100 * rate);
    const totalItems = shopify_cart_items.filter(({ price }) => Number(price) > 0).reduce((acc, cur) => acc + cur.quantity, 0);
    const total = byQuantity ? totalItems : original - bundlesDiscounts;
    const isUnlocked = total >= goalValue
    const variants = gift.products.map(({ variants }, index) => variants?.map(variant => ({ ...variant, gift_index: index }))).filter(Boolean).flat()
    const selectedGift = isPreview ? variants[0] : variants.find(variant => productAddedToCart(variant, true))
    const current = isPreview ? giftCurrentPreview : selectedGift ? 'after' : isUnlocked ? 'selecting' : 'before'
    const pickVariant = (product, onConfirm) => {
        const confirm = (variant) => {
            onConfirm(variant)
            setVariantsPickerShow(false);
        }
        if (Utils.productHasOneVariant(product)) {
            confirm(product.variants[0])
        } else {
            setVariantPickerOptions({
                product,
                buttonText: add_to_unlock.upsell_confirm_button.text,
                onConfirm: confirm
            });
            setVariantsPickerShow(true);
        }
    }
    const addToCart = (product) => {
        pickVariant(product, async (variant) => {
            if (isPreview) return;
            productionAddToCart(shopify_cart_items, { variant_id: variant.id }, async () => {
                if (previous_goal) {
                    const added_gifts_from_previous_goal = getAddedGifts({ goal: previous_goal, productAddedToCart })
                    if (added_gifts_from_previous_goal.length) {
                        const updates = added_gifts_from_previous_goal.reduce((acc, { id }) => ({ ...acc, [id]: 0 }), {})
                        const { data } = await Axios.post(`${origin}/cart/update.js`, { updates })
                        if (data?.items) {
                            setCartItems(data.items)
                        }
                    }
                }
            })
        })
    }
    const changeVariant = async function (product, selectedGift) {
        if (isPreview) return;
        if (gift.products.length > 1) {
            await updateCartItems({ [selectedGift.id]: 0 })
            return;
        }
        const addedVariant = shopify_cart_items.find(({ variant_id }) => variant_id.toString() === selectedGift.id)
        pickVariant(product, async (variant) => {
            if (variant.id === addedVariant.id.toString()) return;
            const updates = {
                [variant.id]: 1,
                [addedVariant.id]: 0
            }
            await updateCartItems(updates)
        })
    }
    const updateCartItems = async (updates) => {
        const { data } = await Axios.post(`${window.location.origin}/cart/update.js`, { updates })
        if (data?.items) {
            setCartItems(data.items)
        }
    }

    const is = (state) => current === state
    const goal_has_a_single_gift = gift.products.length === 1
    const goal_has_multiple_gifts = gift.products.length > 1

    const isRandom = multi_gift_select === "random"
    const gift_is_auto_added = isRandom || (goal_has_a_single_gift && Utils.productHasOneVariant(gift.products[0]))
    const selecting_auto_added = gift_is_auto_added && is('selecting')
    const before_multiple_gifts = (is('before') || selecting_auto_added) && goal_has_multiple_gifts
    const before_single_gift = (is('before') || selecting_auto_added) && goal_has_a_single_gift

    const selecting_multiple_gifts = !gift_is_auto_added && is('selecting')
    // const selecting_single_gift = !gift_is_auto_added && is('selecting') && goal_has_a_single_gift

    return <div className={classNames("rounded border mb-6")} style={{
        background: Utils.formatColor(widget[current].background),
        borderColor: Utils.formatColor(widget[current].outline)
    }}>
        <div className={classNames("text-center p-2 border-b")} style={{
            borderColor: Utils.formatColor(widget[current].outline)
        }} dangerouslySetInnerHTML={{
            __html: formatHeader({
                text: widget[selecting_auto_added ? "before" : current].header, goal, replacedAmountValue, multi_goal_type, formatMoney: (v, f) => Utils.formatMoney(v, money_format, f), filteredItems
            })
        }} />
        <div>
            {before_multiple_gifts && <Widget gift={gift} product={{
                image: widget.before.multi_gift_image,
                title: widget.before.product_name,
                variant_price: gift.products.reduce((acc, cur) => cur.variant_price > acc ? cur.variant_price : acc, 0)
            }} current={widget.before} />}
            {before_single_gift && <Widget gift={gift} product={{
                image: gift.products[0].image,
                title: gift.products[0].title,
                variant_price: gift.products[0].variant_price
            }} current={widget.before} />}
            {selecting_multiple_gifts && <div className={classNames("divide-y")}>
                {gift.products.map(product => <Widget gift={gift} key={product.id} product={product} current={widget.selecting}>
                    <div className={classNames("flex justify-end")}>
                        <button className={classNames("rounded px-2 py-1 cursor-pointer")} onClick={() => addToCart(product)} style={{
                            fontSize: Utils.em(widget.selecting.variant_selector_text.font_size),
                            color: Utils.formatColor(widget.selecting.variant_selector_text.color),
                            backgroundColor: Utils.formatColor(widget.selecting.variant_button_background)

                        }}>{widget.selecting.variant_selector_text.text}</button>
                    </div>
                </Widget>)}
            </div>}
            {/* {selecting_single_gift && <div className={classNames("divide-y")}>
                {gift.products.map(product => <Widget gift={gift} key={product.id} product={product} current={{ ...widget.selecting, product_name: widget.after.product_name }}>
                    <div className={classNames("flex justify-end", { hidden: Utils.productHasOneVariant(gift.products[0]) })}>
                        <button className={classNames("rounded px-2 py-1 cursor-pointer")} onClick={() => addToCart(gift.products[0])} style={{
                            fontSize: Utils.em(widget.selecting.variant_selector_text.font_size),
                            color: Utils.formatColor(widget.selecting.variant_selector_text.color),
                            backgroundColor: Utils.formatColor(widget.selecting.variant_button_background)

                        }}>{widget.selecting.variant_selector_text.text}</button>
                    </div>
                </Widget>)}
            </div>} */}
            {current === "after" && <Widget gift={gift} product={{
                image: selectedGift.image || gift.products[selectedGift.gift_index].image,
                title: gift.products[selectedGift.gift_index].title,
                variant_price: gift.products[selectedGift.gift_index].variant_price
            }} current={widget.after} current_status="after">
                <div className={classNames("flex justify-end", { hidden: isRandom || gift.products.length === 1 && Utils.productHasOneVariant(gift.products[0]) })}>
                    <button className={classNames("rounded px-2 py-1 underline cursor-pointer")} onClick={() => changeVariant(gift.products[selectedGift.gift_index], selectedGift)} style={{
                        fontSize: Utils.em(widget.after.variant_change_text.font_size),
                        color: Utils.formatColor(widget.after.variant_change_text.color),

                    }}>{widget.after.variant_change_text.text}</button>
                </div>
            </Widget>
            }
        </div>
    </div>
}

function formatProductName (text, product_name) {
    return text
        .replace(
            "{{product_name}}",
            product_name
        )
}
function formatCompareAtPrice (text, price) {
    return text
        .replace(
            "{{compare_at_price}}",
            `<del>${price}</del>`
        )
}

function formatHeader ({ text, goal, replacedAmountValue, multi_goal_type, formatMoney, filteredItems }) {
    const replacedAmount = replacedAmountValue > 0 ? formatMoney(replacedAmountValue) : formatMoney("x.xx", v => v);
    const replacedQuantity =
        goal -
        filteredItems
            .map((item) => item.quantity)
            .reduce((acc, item) => acc + item, 0);
    return text
        .replace(
            "{{amount_left}}",
            multi_goal_type === "quantity" ? replacedQuantity : replacedAmount
        )
        .replace("{{goal}}", formatMoney(goal * 100));
}

function Widget ({ gift, image, current, current_status, product, children }) {
    const { widget, products } = gift
    const { cart_settings: { money_format }, cart_settings, Utils, rtl } = useContext(CartContext);
    return (
        <div className={classNames("flex p-2")} style={{ borderColor: Utils.formatColor(current.outline) }}>
            <div
                className={classNames("bg-cover bg-center block relative", {
                    "ml-2": rtl,
                    "mr-2": !rtl
                })}
                style={{
                    backgroundImage: `url(${product?.image || image})`,
                    width: `${cart_settings.product.image_size}px`,
                    height: `${cart_settings.product.image_size}px`
                }}
            >
                {
                    current_status === "after" && <div className={classNames("w-4 h-4 rounded-full absolute flex-center text-white top-3px transform -translate-y-1/2", {
                        "left-3px -translate-x-1/2": rtl,
                        "right-3px translate-x-1/2": !rtl,
                    })} style={{
                        background: Utils.formatColor(widget.after.offer_highlight.color)
                    }}>
                        <svg className={classNames("w-3 h-3")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                    </div>
                }
            </div>
            <div className={classNames("widget flex-1 flex-col")} >
                <div
                    className={classNames("mb-2 overflow-hidden line-clamp")}
                >
                    <span
                        dangerouslySetInnerHTML={{
                            __html: formatProductName(current.product_name, product?.title)
                        }}
                    />
                </div>
                <div>

                    {widget.compare_at_price_active && <b className={classNames(rtl ? "ml-2" : "mr-2")}
                        style={{
                            fontSize: Utils.em(widget.compare_at_price.font_size),
                            fontWeight: widget.compare_at_price.font_weight,
                            color: Utils.formatColor(widget.compare_at_price.color)
                        }}
                        dangerouslySetInnerHTML={{
                            __html: formatCompareAtPrice(widget.compare_at_price.text, Utils.formatMoney(product.variant_price, money_format))
                        }} />}
                    <b
                        className={classNames("flex-1")}
                        style={{
                            fontSize: Utils.em(current.offer_highlight.font_size),
                            fontWeight: current.offer_highlight.font_weight,
                            color: Utils.formatColor(current.offer_highlight.color)
                        }}>{current.offer_highlight.text}</b>
                </div>
                {children}
            </div>
        </div>
    )
}